module.exports = __webpack_public_path__ + "static/media/bf.8c9b84ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bf.svg
// module id = 62
// module chunks = 0